/** Shared list-page access/error handling for Admin CRUD tables. */

export type AdminListAccessState = {
  loading: boolean
  accessDenied: boolean
  loadError: string | null
}

export const initialAdminListAccessState = (): AdminListAccessState => ({
  loading: false,
  accessDenied: false,
  loadError: null,
})

export function parseHttpStatus(error: unknown): number | null {
  const status = (error as { response?: { status?: number } })?.response?.status
  return typeof status === 'number' ? status : null
}

export function resolveAdminListFetchError(error: unknown, fallback: string): AdminListAccessState {
  const status = parseHttpStatus(error)
  if (status === 403) {
    return { loading: false, accessDenied: true, loadError: null }
  }
  const message =
    (error as Error)?.message ||
    (error as { response?: { data?: { message?: string } } })?.response?.data?.message ||
    fallback
  return { loading: false, accessDenied: false, loadError: message }
}

export function adminListEmptyMessage(access: AdminListAccessState, emptyLabel = 'No records found'): string {
  if (access.accessDenied) return 'Access denied. You do not have permission to view this list.'
  if (access.loadError) return access.loadError
  return emptyLabel
}
